import { Cookies } from 'react-cookie';

import { TrapActivityLineChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapsActivityLineChartData = async (
  slug: string,
  period: string,
  trapType: string,
  start_date: string,
  end_date: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/analitycs/total-traps-chart/${slug}/${period}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
      start_date,
      end_date,
    },
  });
  return data.data as TrapActivityLineChartData[];
};
